import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.recamix.com';

export const useSajuApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const analyzeSaju = async (data) => {
    try {
      setLoading(true);
      setError(null);

      console.log('Sending request to:', `${API_URL}/fortune/saju`);
      console.log('Request data:', data);

      const response = await fetch(`${API_URL}/fortune/saju`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)  // questionType이 이미 포함되어 있으므로 그대로 전송
      });

      console.log('Response status:', response.status);

      const responseData = await response.json();

      if (!response.ok) {
        console.log('Error response:', responseData);
        throw new Error(JSON.stringify(responseData));
      }

      setResult(responseData.data);
      return responseData.data;

    } catch (error) {
      console.log('API Error:', error);
      setError(error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const clearResult = () => setResult(null);
  const clearError = () => setError(null);

  return {
    loading,
    error,
    result,
    analyzeSaju,
    clearResult,
    clearError
  };
}; 